import { render, staticRenderFns } from "./Clients_Delete.vue?vue&type=template&id=20c9818a&scoped=true"
import script from "./Clients_Delete.vue?vue&type=script&lang=js"
export * from "./Clients_Delete.vue?vue&type=script&lang=js"
import style0 from "./Clients_Delete.vue?vue&type=style&index=0&id=20c9818a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9818a",
  null
  
)

export default component.exports